import { CompChartPieCore } from '../core/charts/pie-chart/comp'

export const CompChartPie = CompChartPieCore
